import { AbstractPlugin } from '../index';

// TODO: 注册必须用
export class TextLoader extends AbstractPlugin {
}
